import { TreeView } from "@progress/kendo-react-treeview";

function MenuItemTreeView(props) {
    return (
        <TreeView
            {...props}
        />
    )
}

export default MenuItemTreeView;